/**
 * GrowthBook flag to enable Redis caching
 */
import type { GetServerSidePropsContext } from 'next'
import { getBucket } from '@mc/next-growthbook'

// https://app.growthbook.io/features/pen-3904_v1
export const REDIS_CACHE_FLAG = 'pen-3904_v1'

export const isRedisCacheEnabled = async (ctx: GetServerSidePropsContext) =>
  (await getBucket(ctx, REDIS_CACHE_FLAG)) === 'variant_1'
